import type { ProjectId } from 'owa-timestream-types';

/** A map between project IDs and generated todo folder IDs (or its promise). */
export default new Map<ProjectId, string | Promise<string>>();
